
export default {
  name: 'CompanyReports',
  fetchOnServer: false,
  props: {
    symbol: {
      type: String,
      default: null,
    },
    reportType: {
      type: String,
      default: '',
    },
    take: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      reports: null,
      loading: true,
      apiOptions: {
        params: {
          lang: this.$i18n.locale,
          h7_datetime_format: 'MMM dd, yyyy HH:mm:ss',
          take: 20,
          skip: 0,
          announcement_type: 'Disclosure',
          types: this.reportType,
          symbol: this.symbol,
          cms_resources: true,
        },
      },
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    /**
     * Fetch reports from the API based on the provided symbol and report type.
     * This method is called when the component is mounted.
     * It retrieves the reports and updates the component's state.
     * @returns {Promise<void>} A promise that resolves when the fetch operation is complete.
     */
    async fetch() {
      // console.log('Fetching reports for symbol:', this.symbol)
      this.loading = true
      try {
        const response = await this.$axios.get(`${this.$config.apiEfsahUrl}/prototype_efsah`, {
          params: {
            announcement_type: 'Disclosure',
            types: this.reportType,
            symbol: this.symbol,
            take: this.take,
            lang: this.$i18n.locale,
            cms_resources: true,
          },
        })
        // console.log('Response data:', response)
        this.reports = response.data.root
        this.$emit('fetchCompleted')
        this.loading = false
      } catch (error) {
        // console.log(error)
      }
    }
  }
}
